import styled from "styled-components";

import { colors } from "../../../../../consts";
import { device } from "../../../../../services";

import { Paragraph2, SmallButtonStyled, WrapperContainer } from "../../../../../components";
import { DateInputContainer } from "../../../../../components/DateInput/styled";

export const RoleCardWrapper = styled(WrapperContainer)`
  width: 100%;
  padding: 16px;

  border-radius: 16px;
  border: 1px solid;
  border-color: ${(props) => (props?.hasError ? colors.ERROR : colors.RAISIN_10)};
`;

export const Title = styled(Paragraph2)`
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
`;

export const Subtitle = styled(Paragraph2)`
  color: ${(props) => (props?.hasError ? colors.ERROR : colors.RAISIN_70)};
`;

export const RoleDateInfo = styled(Paragraph2)`
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => (props?.isExipred ? colors.ERROR : colors.RAISIN_80)};
`;

export const ButtonsWrapper = styled(WrapperContainer)`
  ${SmallButtonStyled} {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 16px;
    font-weight: 600;

    width: 105px;
    height: 40px;
    padding: unset;

    svg {
      path {
        transition: 0.5s all;
      }
    }

    &:active {
      svg {
        path {
          fill: ${colors.ISABELLINE};
        }
      }
    }
  }
`;

export const RolesListContainer = styled(WrapperContainer)`
  display: ${(props) => (props?.hasRoles ? "grid" : "flex")};
  grid-gap: 16px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;

  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 100%;
  min-height: 220px;

  > ${Paragraph2} {
    font-weight: 500;
    color: ${colors.RAISIN_50};
  }

  @media screen and ${device.notebook} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  @media screen and ${device.laptop} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const DateRangeInputWrapper = styled(WrapperContainer)`
  width: 100%;
  min-width: 300px;

  position: relative;

  ${DateInputContainer} {
    max-width: unset;
  }
`;
